import timePeriodList from './time-period-none';
import timePeriodSectionCategory from './time-period-section-category';
import editor from '../AssignmentInitialDecision/editor';
import initialDecisionsNone from './initial-decision-none';
import manuscriptTypeNone from '../AssignmentInitialDecision/manuscriptType';

export default [...timePeriodList, ...timePeriodSectionCategory, ...editor,...initialDecisionsNone,...manuscriptTypeNone];